<template>
  <div>
    <p>Sound {{ state.trial_index + 1 }} of {{ stage.trials.length }}</p>
    <AudioPlayer :stage-id="stage.id" :src="trial.audio" :label="trial.label" :material-id="trial.id" :disabled="disabled" @action="$emit('action', $event)" />
    <div class="tile-row" role="group" aria-label="Choose a letter">
      <button v-for="letter in stage.letters" :key="letter" class="letter-tile" :class="{ chosen: state.answers[trial.id] === letter }" :aria-pressed="state.answers[trial.id] === letter" :disabled="disabled" @click="$emit('action', { type: 'letter_select', letter })">{{ letter }}</button>
    </div>
    <p class="muted">The sounds are not available yet. Choices are saved as preview responses, without a correctness score.</p>
    <button v-if="state.trial_index < stage.trials.length - 1" :disabled="disabled || !state.answers[trial.id]" @click="$emit('action', { type: 'trial_next' })">Save choice · Next sound</button>
    <p v-else role="status">Last sound. Save this activity when you are ready.</p>
  </div>
</template>
<script>
import AudioPlayer from './AudioPlayer.vue';
export default { components: { AudioPlayer }, props: { stage: Object, state: Object, disabled: Boolean }, emits: ['action'], computed: { trial() { return this.stage.trials[this.state.trial_index]; } } };
</script>

